module.exports = __webpack_public_path__ + "img/华能-1.654013ff.png";